import React, { FC, createContext, useState } from 'react';

import { lightTheme } from 'utils/styles/theme';

export const ThemeMode = createContext({
  toggleThemeMode: () => {},
  darkMode: false,
  theme: lightTheme,
});

export const ThemeModeProvider: FC = ({ children }) => {
  const [darkMode, setDarkMode] = useState<boolean>(false);
  const [theme, setTheme] = useState(lightTheme);

  const toggleThemeMode = () => {
    setDarkMode(!darkMode);
    setTheme(lightTheme);
  };

  return (
    <ThemeMode.Provider value={{ toggleThemeMode, darkMode, theme }}>
      {children}
    </ThemeMode.Provider>
  );
};
